/**
 * Comprehensive list of Stripe tax codes
 * Source: https://docs.stripe.com/tax/tax-codes
 */

export const STRIPE_TAX_CODES = [
    // General categories
    { code: 'txcd_99999999', name: 'General - Tangible Goods', category: 'Physical goods' },
    { code: 'txcd_20030000', name: 'General - Services', category: 'Services' },
    { code: 'txcd_10000000', name: 'General - Electronically Supplied Services', category: 'Digital products' },
    { code: 'txcd_00000000', name: 'Nontaxable', category: 'Physical goods' },
    
    // Digital products
    { code: 'txcd_10010001', name: 'Infrastructure as a service (IaaS) - personal use', category: 'Digital products' },
    { code: 'txcd_10101000', name: 'Infrastructure as a service (IaaS) - business use', category: 'Digital products' },
    { code: 'txcd_10102000', name: 'Platform as a service (PaaS) - business use', category: 'Digital products' },
    { code: 'txcd_10102001', name: 'Platform as a Service (PaaS) - personal use', category: 'Digital products' },
    { code: 'txcd_10103000', name: 'Software as a service (SaaS) - personal use', category: 'Digital products' },
    { code: 'txcd_10103001', name: 'Software as a service (SaaS) - business use', category: 'Digital products' },
    { code: 'txcd_10103100', name: 'Software as a service (SaaS) - electronic download - personal use', category: 'Digital products' },
    { code: 'txcd_10103101', name: 'Software as a service (SaaS) - electronic download - business use', category: 'Digital products' },
    { code: 'txcd_10104001', name: 'Cloud-based business process as a service', category: 'Digital products' },
    { code: 'txcd_35060000', name: 'Digital goods', category: 'Digital products' },
    
    // Physical goods
    { code: 'txcd_10000000', name: 'Physical goods', category: 'Physical goods' },
    
    // Services
    { code: 'txcd_30070000', name: 'Professional services', category: 'Services' },
    { code: 'txcd_50021001', name: 'Fitness Centers - Dues and Membership Fees', category: 'Services' },
    { code: 'txcd_50021002', name: 'Fitness Centers - Initiation Fees', category: 'Services' },
    { code: 'txcd_50021003', name: 'Fee for Personal Training/Fitness Classes', category: 'Services' },
    { code: 'txcd_50021101', name: 'Fitness Centers - Single Use Access Fees', category: 'Services' },
    { code: 'txcd_50021103', name: 'Fee For Sport Instruction Classes', category: 'Services' },
    { code: 'txcd_90020001', name: 'Optional Gratuity', category: 'Services' },
    
    // Other common categories
    { code: 'txcd_90000001', name: 'Cash Donation', category: 'Physical goods' },
    { code: 'txcd_92010001', name: 'Shipping', category: 'Physical goods' }
];

/**
 * Returns a filtered list of tax codes grouped by category
 * @param {string} filter Optional filter string to search in code or name
 * @returns {Object} Object with category keys and arrays of tax codes as values
 */
export const getGroupedTaxCodes = (filter = '') => {
    const lowerFilter = filter.toLowerCase();
    const filteredCodes = STRIPE_TAX_CODES.filter(
        code => code.name.toLowerCase().includes(lowerFilter) || 
                code.code.toLowerCase().includes(lowerFilter)
    );
    
    return filteredCodes.reduce((groups, code) => {
        const category = code.category;
        if (!groups[category]) {
            groups[category] = [];
        }
        groups[category].push(code);
        return groups;
    }, {});
};

/**
 * Common tax codes that are most frequently used
 */
export const COMMON_TAX_CODES = [
    { code: 'txcd_99999999', name: 'General - Default' },
    { code: 'txcd_20030000', name: 'Software as a service (SaaS)' },
    { code: 'txcd_30070000', name: 'Professional services' },
    { code: 'txcd_35060000', name: 'Digital goods' },
    { code: 'txcd_10000000', name: 'Physical goods' },
]; 